import React from 'react';

export const SiteVisitMeasurementsView = ({ siteVisitData }) => {
  if (!siteVisitData || !siteVisitData.rooms || siteVisitData.rooms.length === 0) {
    return (
      <div className="text-slate-400 italic text-[13px]">
        No measurements recorded for this site visit.
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      {siteVisitData.rooms.map(room => {
        const roomMeasurements = siteVisitData.measurements?.filter(m => m.room === room) || [];
        if (roomMeasurements.length === 0) return null;

        return (
          <div key={room} className="mb-2">
            <h4 className="text-[12px] font-bold text-slate-700 mb-2 uppercase border-b border-slate-100 pb-1 inline-block">
              {room}
            </h4>
            <div className="flex flex-col gap-2">
              {roomMeasurements.map((m, idx) => {
                const dims = [m.width ? `W: ${m.width}` : '', m.height ? `H: ${m.height}` : '', m.depth ? `D: ${m.depth}` : ''].filter(Boolean).join(' x ');
                return (
                  <div key={idx} className="text-[12px] text-slate-600 bg-slate-50 p-2 rounded">
                    {m.zone && <div className="mb-0.5"><span className="font-semibold text-slate-700">Zone:</span> {m.zone}</div>}
                    {dims && <div className="mb-0.5"><span className="font-semibold text-slate-700">Dimensions:</span> {dims}</div>}
                    {m.qty && <div className="mb-0.5"><span className="font-semibold text-slate-700">Qty:</span> {m.qty}</div>}
                    {m.particulars && <div className="mb-0.5"><span className="font-semibold text-slate-700">Particulars:</span> {m.particulars}</div>}
                    {m.notes && <div><span className="font-semibold text-slate-700">Notes:</span> {m.notes}</div>}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
      {siteVisitData.commonNotes && (
        <div className="mt-2 text-[12px]">
          <span className="font-semibold text-slate-700">Site Visit General Notes:</span>
          <p className="text-slate-600 italic mt-1">{siteVisitData.commonNotes}</p>
        </div>
      )}
    </div>
  );
};

export default SiteVisitMeasurementsView;
